<template>
    <div class="login-wrap">
        <div class="top">
            <img src="../../assets/img/logo.png" class="logo" @click="openPage('/home')" />
            <div class="header-user-con">
                <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="openPage('/home')">首页</div>
                <div class="el-lable" style="margin-left: 5px;margin-right: 5px;">|</div>
                <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="openPage('/help')">帮助中心</div>
            </div>
        </div>
        <div class="bottom">
            <span class="footertitle">备案号：浙ICP备2024099507号-1</span>
            <span class="footertitle"> 杭州奕游网络科技有限公司版权所有</span>
        </div>

        <el-card shadow="always" class="ms-login" v-if="logonmodel">

            <el-tabs v-model="activeName">
                <el-tab-pane label="密码登录" name="first">
                    <el-form :model="ruleLogonForm" ref="ruleLogonForm" label-width="0px" class="ms-content">
                        <el-form-item prop="mobile">
                            <el-input v-model="ruleLogonForm.mobile" placeholder="请输入手机号码" size="medium">
                                <el-button slot="prepend" class="inputicon">+86</el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" :show-password="true" placeholder="请输入登录密码"
                                v-model="ruleLogonForm.password">
                                <el-button slot="prepend" icon="el-icon-lx-lock" class="inputicon"></el-button>
                            </el-input>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="logonByPassWord()">登 录</el-button>
                        </div>
                        <p class="login-tips">Tips : 用户名和密码随便填。</p>
                    </el-form>

                </el-tab-pane>
                <el-tab-pane label="验证码登录" name="second">
                    <el-form :model="ruleLogonForm" ref="ruleLogonForm" label-width="0px" class="ms-content">
                        <el-form-item prop="mobile">
                            <el-input v-model="ruleLogonForm.mobile" placeholder="请输入手机号码" size="medium" maxlength="11"
                                minlength="11">
                                <el-button slot="prepend" class="inputicon">+86</el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="pinCode">
                            <el-input v-model="ruleLogonForm.pinCode" placeholder="验证码" size="medium" maxlength="6"
                                minlength="6" style="width: 210px;">
                                <el-button slot="prepend" icon="el-icon-message" class="inputicon"></el-button>
                            </el-input>
                            <el-button plain class="sendPinCode" @click="sendPinCode('logon')"
                                :disabled="enableSendLogonSms">{{ logonSmsBtnText }}</el-button>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="logonByPinCode()">登 录</el-button>
                        </div>
                        <p class="login-tips">Tips : 用户名和密码随便填。</p>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <label class="btnRegist" style="margin-bottom: 20px;" @click="onTabRegist()">注册账号</label>
        </el-card>
        <el-card shadow="always" class="ms-login ms-register" v-if="!logonmodel">
            <el-tabs v-model="activeNameReg">
                <el-tab-pane label="注册账号" name="first">
                    <el-form :model="ruleRegistForm" ref="ruleRegistForm" label-width="0px" class="ms-content">
                        <el-form-item prop="mobile">
                            <el-input v-model="ruleRegistForm.mobile" placeholder="请输入手机号码" size="medium" maxlength="11"
                                minlength="11">
                                <el-button slot="prepend" class="inputicon">+86</el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="pinCode">
                            <el-input v-model="ruleRegistForm.pinCode" placeholder="验证码" size="medium" maxlength="6"
                                minlength="6" style="width: 210px;">
                                <el-button slot="prepend" icon="el-icon-message" class="inputicon"></el-button>
                            </el-input>
                            <el-button class="sendPinCode" @click="sendPinCode('regist')"
                                :disabled="enableSendRegistSms">{{ registSmsBtnText }}</el-button>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" placeholder="设置登录密码" v-model="ruleRegistForm.password"
                                :show-password="true">
                                <el-button slot="prepend" icon="el-icon-lx-lock" class="inputicon"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="passwordAgain">
                            <el-input type="password" placeholder="确认登录密码" v-model="ruleRegistForm.passwordAgain"
                                :show-password="true">
                                <el-button slot="prepend" icon="el-icon-lx-lock" class="inputicon"></el-button>
                            </el-input>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="submitFormRegist()">注 册</el-button>
                        </div>
                        <p class="login-tips">Tips : 用户名和密码随便填。</p>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <label class="gotoLogon" @click="onTabLogon()">已有账号,去登录</label>

        </el-card>

    </div>
</template>

<script>
import netutil from '../common/netutil.js';
import accounts from '../common/accounts.js';

export default {
    data: function () {
        return {
            activeName: "first",
            activeNameReg: "first",
            logonmodel: true,
            enableSendLogonSms: false,
            enableSendRegistSms: false,
            logonSMStimer: null,
            registSMStimer: null,
            logonSMSCount: 0,
            registSMSCount: 0,
            ruleLogonForm: {
                mobile: '',
                pinCode: '',
                password: '',
            },
            rulesLogon: {
                username: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ]
            },

            ruleRegistForm: {
                mobile: '',
                pinCode: '',
                password: '',
                passwordAgain: ''
            },
            rulesRegist: {
                mobile: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' }
                ],
                pinCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],

                password: [
                    { required: true, message: '请设置登录密码', trigger: 'blur' }
                ],
                passwordAgain: [
                    { required: true, message: '请再次输入登录密码', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        let model = this.$route.query.model;
        this.logonmodel = (model == 'logon' || !model);
    },
    computed: {
        logonSmsBtnText() {
            if (this.logonSMSCount == 0) return '发送';
            else return this.logonSMSCount + 'S';

        },
        registSmsBtnText() {
            if (this.registSMSCount == 0) return '发送';
            else return this.registSMSCount + 'S';

        }


    },
    methods: {
        openPage(url) {
            this.$router.push(url);
        },
        onTabRegist() {
            this.logonmodel = false;
        },

        onTabLogon() {
            this.logonmodel = true;
        },
        logonByPinCode() {
            if (this.ruleLogonForm.mobile.length != 11) {
                this.$message.error('请输入有效的手机号码!');
                return;
            }
            if (this.ruleLogonForm.pinCode.length != 6) {
                this.$message.error('请输入有效的验证码!');
                return;
            }



            var self = this;
            var param = {
                platformID: 0,
                accounts: this.ruleLogonForm.mobile,
                pincode: this.ruleLogonForm.pinCode
            };
            netutil.get("accounts/logonbypincode", param,
                function (data) {
                    self.$message.success('登录成功！');
                    localStorage.setItem('UserID', data.data0[0].UserID);
                    localStorage.setItem('SessionID', data.data0[0].SessionID);
                    self.$router.push('/');

                },
                function (msg) {
                    self.$message.error(msg);
                });



        },
        logonByPassWord() {

            if (this.ruleLogonForm.mobile.length != 11) {
                this.$message.error('请输入有效的手机号码!');
                return;
            }
            if (this.ruleLogonForm.password.length < 7) {
                this.$message.error('密码长度要大于6位，请重新输入!');
                return;
            }


            var self = this;
            var param = {
                platformID: 0,
                accounts: this.ruleLogonForm.mobile,
                password: this.$md5(this.ruleLogonForm.password)
            };
            netutil.get("accounts/logonbyaccounts", param,
                function (data) {
                    self.$message.success('登录成功！');
                    localStorage.setItem('UserID', data.data0[0].UserID);
                    localStorage.setItem('SessionID', data.data0[0].SessionID);
                    self.$router.push('/');

                },
                function (msg) {
                    self.$message.error(msg);
                });
        },
        sendPinCode(type) {

            var self = this;
            var param = {};

            if ('logon' == type) {
                if (this.ruleLogonForm.mobile.length != 11) {
                    this.$message.error('请输入有效的手机号码!');
                    return;
                }

                this.enableSendLogonSms = true;
                this.logonSMSCount = 60;
                this.logonSMStimer = setInterval(() => {
                    if (this.logonSMSCount > 0) {
                        this.logonSMSCount -= 1;
                    } else {
                        if (this.logonSMStimer) {
                            clearInterval(this.logonSMStimer);
                            this.logonSMStimer = null;
                        }
                        this.enableSendLogonSms = false;
                    }
                }, 1000);
                param = {

                    phone: this.ruleLogonForm.mobile,
                    type: type
                };
            }
            else {
                if (this.ruleRegistForm.mobile.length != 11) {
                    this.$message.error('请输入有效的手机号码!');
                    return;
                }
                this.enableSendRegistSms = true;
                this.registSMSCount = 60;
                this.registSMStimer = setInterval(() => {
                    if (this.registSMSCount > 0) {
                        this.registSMSCount -= 1;
                    } else {
                        if (this.registSMStimer) {
                            clearInterval(this.registSMStimer);
                            this.registSMStimer = null;
                        }
                        this.enableSendRegistSms = false;
                    }
                }, 1000);
                param = {
                    phone: this.ruleRegistForm.mobile,
                    type: type
                };

            }

            netutil.get("public/getsmscode", param,
                function (data) {
                    self.$message.success('发送成功！');


                },
                function (msg) {
                    self.$message.error(msg);
                });

        },
        submitFormRegist() {

            if (this.ruleRegistForm.mobile.length != 11) {
                this.$message.error('请输入有效的手机号码!');
                return;
            }
            if (this.ruleRegistForm.pinCode.length != 6) {
                this.$message.error('请输入有效的验证码!');
                return;
            }
            if (this.ruleRegistForm.password != this.ruleRegistForm.passwordAgain) {
                this.$message.error('两次密码不同，请重新输入!');
                return;
            }
            if (this.ruleRegistForm.password.length < 7) {
                this.$message.error('密码长度要大于6位，请重新输入!');
                return;
            }

            var self = this;
            var param = {
                accounts: this.ruleRegistForm.mobile,
                password: this.$md5(this.ruleRegistForm.password),
                platformID: 0,
                pin: this.ruleRegistForm.pinCode
            };
            netutil.get("accounts/registeraccounts", param,
                function (data) {
                    self.$message.success('注册成功！');
                    localStorage.setItem('UserID', data.data0[0].UserID);
                    localStorage.setItem('SessionID', data.data0[0].SessionID);
                    self.$router.push('/');
                },
                function (msg) {
                    self.$message.error(msg);
                });
        }
    }
}

</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/bg.jpg);
    background-size: 100%;
}


.top {
    height: 80px;
    background-color: #ffffff;
}

.bottom {
    position: absolute;
    height: 60px;
    width: 100%;
    bottom: 0;
    background-color: #ffffff;
    text-align: center;
    padding-top: 10px;

}

.footertitle {
    color: rgb(85, 85, 85);
    text-align: center;
    line-height: 30px;
    padding-top: 60px;
}

.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}

.ms-login {
    position: absolute;
    left: calc(50% + 100px);
    top: calc(50% - 200px);
    width: 400px;
    height: 400px;
    border-radius: 15px;
}

.ms-register {
    height: 560px;
    top: calc(50% - 280px);
}

.ms-content {
    padding: 20px 20px;
}

.login-btn {
    text-align: center;
}

.login-btn button {
    width: 100%;
    height: 56px;
    font-size: 24px;
    border-color: #ff8800;
    border-radius: 28px;
    background-color: #ff8800;
    box-shadow: 2px 2px 2px 2px #d7d7d7;
}

.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}

/deep/.el-input__inner {
    height: 48px;
    background-color: #faf5f500 !important;
    margin: 0px !important;
    border-radius: 0px;
    border: 0px solid #faf5f500;
    font-size: 18px;

}

.el-form-item {
    margin-bottom: 30px;
}

.el-input-group {
    height: 48px;
    line-height: 48px;
    border: 1px solid #757575;
    border-radius: 6px;
    font-size: 18px;
    color: #2e2e2e;
}


.inputicon {
    background-color: #faf5f500 !important;
    height: 100% !important;
    width: 100% !important;
    color: #9d9d9d !important;
    margin: 0px !important;
    padding: 0px !important;
    font-size: 20px;
    cursor: auto;

}

/deep/.el-input-group__prepend {
    background-color: #faf5f500 !important;
    margin: 0px !important;
    border-radius: 0px;
    border: 0px solid #faf5f500;
}

/deep/.el-form-item__error {
    line-height: 24px !important;
    margin-left: 70px !important;
    margin-top: 2px;
}

.headTitle {
    font-size: 20px;
    color: #878787;
}

.logo {
    width: 260px;
    height: 60px;
    margin-left: 100px;
    margin-top: 10px;
    cursor: pointer;
}

.btnClose {
    font-size: 32px;
    color: #757575;
    float: right;
    margin-right: -10px;
    margin-right: -10px;
    cursor: pointer;
}

.gotoLogon {
    bottom: 12px;
    right: 20px;
    position: absolute;
    color: #5f5f5f;
    text-decoration: underline;
    cursor: pointer;
}

.btnRegist {
    color: #5f5f5f;
    text-decoration: underline;
    cursor: pointer;
    bottom: 0;
    right: 20px;
    position: absolute;
}

.sendPinCode {
    float: right;
    height: 52px;
    width: 95px;
    z-index: 999;
    font-size: 16px;
    border-radius: 6px;
}

.header-user-con {
    display: flex;
    height: 40px;
    align-items: center;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
}
</style>